(function () {
    window.getOS = () => {
        let userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.includes(platform)) {
            os = 'macos';
        } else if (iosPlatforms.includes(platform)) {
            os = 'ios';
        } else if (windowsPlatforms.includes(platform)) {
            os = 'windows';
        } else if (/Android/.test(userAgent)) {
            os = 'android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'linux';
        }

        return os;
    };

    /* IE CHECK */
    let isIE = false;
    let ieVer, isAtLeastIE11;

    // Returns the version of Internet Explorer or a -1
    // (indicating the use of another browser).
    function getInternetExplorerVersion() {
        const userAgent = navigator.userAgent;
        const msieMatch = /MSIE (\d+[.\d]*)/.exec(userAgent);
        if (msieMatch) {
            return Number.parseFloat(msieMatch[1]);
        }
        const ie11Match = /Trident\/.*rv:(\d+[.\d]*)/.exec(userAgent);
        if (ie11Match) {
            return Number.parseFloat(ie11Match[1]);
        };
        return -1;
    };

    ieVer = getInternetExplorerVersion();
    isAtLeastIE11 = !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/));

    if (ieVer > 0 || isAtLeastIE11) {
        isIE = true;
    }

    window.isIE = isIE;
    window.ieVer = ieVer;
    window.isAtLeastIE11 = isAtLeastIE11;

    if (ieVer === 9) {
        if (!(window.console && console.log)) {
            console = { 
                log: function () {},
                debug: function () {},
                info: function () {},
                warn: function () {},
                error: function () {}
            };
        }
    }

    /* func: debounce
    TODO: desciption
    */
    window.debounce = (func, wait, immediate) => {
        let timeout;

        return () => {
                let args = arguments,
                later = function () {
                    timeout = null;
                    if (!immediate) {
                        func.apply(this, args);
                    }
                },

                callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(this, args);
            }
        };
    };
})();
